module.exports = __webpack_public_path__ + "img/9_121.3a0356ff.png";